import { render, staticRenderFns } from "./PreliminaryTypeSelector.vue?vue&type=template&id=20246a2e&scoped=true&"
import script from "./PreliminaryTypeSelector.vue?vue&type=script&lang=js&"
export * from "./PreliminaryTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PreliminaryTypeSelector.vue?vue&type=style&index=0&id=20246a2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20246a2e",
  null
  
)

export default component.exports